import cx from 'classnames';
import React from 'react';

import './spec-course-lesson-view__section-content.scss';

interface Props {
    children: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
}

export const SpecCourseLessonViewSectionContent = React.memo(({ children, mix }: Props) => {
    return <div className={cx('spec-course-lesson-view__section-content', mix)}>{children}</div>;
});
